import port from '@config/port';
import { defineStore } from 'pinia';
import systemInfo from './systemInfo';
import { USER_INFO } from '@config/constant';
import request, { mergeReq } from '@utils/request';
import { ref, computed } from 'vue';

export default defineStore('projectData', () => {
	const config = ref<any>({});
	const userInfo = ref<any>({});
	const shareData = ref({
		path: '',
		title: '',
		imageUrl: '',
	});
	const versionData = ref({
		isOnline: 0,
	});
	const thumbResources = ref<any>();

	const isOnline = computed(() => versionData.value.isOnline == 1);

	const getThumb = (key: string) => thumbResources.value?.[key] || '';

	async function fetchThumbResources() {
		const res = await request.get(port.API_GETTHUMBLIST);
		thumbResources.value = res;
	}

	async function getTimestamp() {
		const { timestamp } = await fetchConfig('init');
		return Number(timestamp) * 1000;
		// return AES.encrypt(timestamp);
	}

	function getCreditName(type: string) {
		const list = config.value.creditList || [];
		for (const val of list) {
			if (val.creditType == type) {
				return val.creditName;
			}
		}
		return '';
	}

	async function getShareData() {
		request
			.get({
				showLoad: false,
				params: { sourceType: 1 },
				port: port.SHARE_GETSHAREDATA,
			})
			.then(({ thumb, title, url }) => {
				shareData.value.path = url;
				shareData.value.title = title;
				shareData.value.imageUrl = thumb;
			});
	}

	async function fetchUserInfo(type: string = 'default'): Promise<any> {
		if (Object.keys(userInfo.value).length > 0 && type == 'default') {
			return userInfo.value;
		} else if (systemInfo().token) {
			try {
				const info = await mergeReq({ port: port.MEMBER_GETMEMBERDETAIL });
				userInfo.value = info;
				uni.setStorageSync(USER_INFO, info);
				return info;
			} catch {
				userInfo.value = {};
				return {};
			}
		} else {
			userInfo.value = {};
			return {};
		}
	}

	async function fetchConfig(type: string = 'default'): Promise<any> {
		if (Object.keys(config.value).length > 0 && type == 'default') {
			return config.value;
		} else {
			try {
				const configData = await mergeReq({ port: port.SYSTEM_GETSETDATA });
				config.value = configData;
				return configData;
			} catch {
				return config.value;
			}
		}
	}

	async function fetchVersionData(): Promise<any> {
		try {
			const info = await mergeReq({ port: port.VERSION_GETVERSION });
			versionData.value = info;
			return info;
		} catch {
			return versionData.value;
		}
	}

	fetchVersionData();

	return {
		config,
		userInfo,
		shareData,
		versionData,
		isOnline,
		getThumb,
		getTimestamp,
		getCreditName,
		getShareData,
		fetchUserInfo,
		fetchConfig,
		fetchVersionData,
		thumbResources,
		fetchThumbResources,
	};
});
